import React, { useState } from 'react';
import TaskHistory from './TaskHistory';
import './TaskHistoryButton.css';

const TaskHistoryButton = ({ taskId, className = '', children, ...props }) => {
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);

  const handleOpenHistory = () => {
    setIsHistoryOpen(true);
  };

  const handleCloseHistory = () => {
    setIsHistoryOpen(false);
  };

  return (
    <>
      <button
        className={`task-history-button ${className}`}
        onClick={handleOpenHistory}
        {...props}
      >
        {children || (
          <>
            <span className="history-button-icon">📋</span>
            History
          </>
        )}
      </button>

      <TaskHistory
        taskId={taskId}
        isOpen={isHistoryOpen}
        onClose={handleCloseHistory}
      />
    </>
  );
};

export default TaskHistoryButton;
